import { roadC } from "../utils/roadC";
import RoadMapGeneric from "../components/Roadmaps/RoadMapGeneric";

const RoadMapC = (props) => <RoadMapGeneric {...props} roadData={roadC} />;
export default RoadMapC;